function iso7064Mod9710(iban: string): number {
    let remainder = iban;
    let block;

    while (remainder.length > 2) {
        block = remainder.slice(0, 9);
        remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
    }

    return parseInt(remainder, 10) % 97;
}

export function validateIban(str: string | null | undefined): boolean {
    if (str === null || str === undefined) {
        return false;
    }
    const pattern = /IR[0-9]{24}/;

    if (str.length !== 26) {
        return false;
    }

    if (!pattern.test(str)) {
        return false;
    }

    let newStr = str.substr(4);
    const d1 = str.charCodeAt(0) - 65 + 10;
    const d2 = str.charCodeAt(1) - 65 + 10;
    newStr += d1.toString() + d2.toString() + str.substr(2, 2);

    const remainder = iso7064Mod9710(newStr);
    return remainder === 1;
}

export type ValidateIban = typeof validateIban;

export function validateCreditCard(card: string | null | undefined) {
    if (typeof card === 'undefined' || card === null || card.length !== 16) {
        return false;
    }
    let cardTotal = 0;
    for (let i = 0; i < 16; i++) {
        const c = Number(card[i]);
        if (i % 2 === 0) {
            cardTotal += c * 2 > 9 ? c * 2 - 9 : c * 2;
        } else {
            cardTotal += c;
        }
    }
    return cardTotal % 10 === 0;
}

export type ValidateCreditCard = typeof validateCreditCard;
